import React from "react";

// Wraps the first occurrence of `word` inside `text` with a colored span.
// Case-insensitive match; leaves the rest of the string in default color.
export const Highlight = ({ text, word, className = "" }) => {
  if (!text || !word) return <>{text}</>;
  const idx = text.toLowerCase().indexOf(word.toLowerCase());
  if (idx === -1) return <>{text}</>;
  const before = text.slice(0, idx);
  const match = text.slice(idx, idx + word.length);
  const after = text.slice(idx + word.length);
  return (
    <>
      {before}
      <span className={className}>{match}</span>
      {after}
    </>
  );
};
